import { Input, Switch, Table } from "antd";
import { useEffect, useState } from "react";
import CardPage from "../../../layout/CardPage";
import { useColumns } from "./useColumns";
import axios from "axios";
import { URL_BASE_ORDENESPAGO } from "../../../constants/url";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { UseNoRepeatArrayOP } from "../../../hooks/UseNoRepeatArrayOP";
import { StatsTable } from '../StatsTable';
import { getStats } from '../../../utils/getStatsOP';
import { BotonAutorizarMasivo } from "./_BotonAutorizarMasivo";

export const Autorizar = () => {

  const [ listaCompleta, setListaCompleta ] = useState([]);
  const [ listaFinal, setListaFinal ] = useState([]);
  const [ switchState, setSwitchState ] = useState(false);
  const [ filtro, setFiltro ] = useState("sin");
  const [ searchText, setSearchText ] = useState("");
  const filters = UseNoRepeatArrayOP(listaFinal,["cliente", "proveedor"])

  const getAutorizarByStatus = async (obj) => {
    setListaCompleta([])
    setListaFinal([])
    const { data } = await axios.post(`${URL_BASE_ORDENESPAGO}/getOrdenesPorAutorizar`, obj)
    console.log('Datos recibidos:', data)
    setListaCompleta(data)
    setListaFinal(data)
  }
  useEffect(() => {
    getAutorizarByStatus({ verPendientes: false, filtro: "sin" })
  }, []);

  const handleSwitch = (checked) => {
    setSwitchState(checked)
    if (checked) {
      return getAutorizarByStatus({ verPendientes: true, filtro })

    }
    return getAutorizarByStatus({ verPendientes: false, filtro })
  }

  const handleFiltroChange = (newFiltro) => {
    setFiltro(newFiltro)
    getAutorizarByStatus({ verPendientes: switchState, filtro: newFiltro })
  }
//

  const { columns } = useColumns(switchState, handleSwitch, filters);
  function debounce(func, timeout = 200) {
    let timer;
    return (...arg) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, arg);
      }, timeout);
    };
  }

  function onChangeInput(event) {
    const value = event.target.value;
    setSearchText(value);

    if (value === "") {
      setListaFinal(listaCompleta);
    } else {
      const filtered = listaCompleta.filter(item =>
        item.ordenPagoID?.toString().includes(value)
      );
      setListaFinal(filtered);
    }
  }

  const change = debounce(onChangeInput);

  //
  const {totalCash, totalItems} = getStats(listaFinal)
  return (
    <CardPage>


      <div style={{ display: 'flex', gap: '30px', alignItems: "center", marginBottom: '30px' }}>

        <div style={{ width: "200px" }}>
          <Input onChange={change} placeholder={"Buscar por ID"} />
        </div>

        <div>
          {/* <p style={{ margin: 0, display: "inline-block", marginRight: "10px" }}>Ver todas</p>
          <Switch
            size='small'
            defaultChecked={switchState}
            onChange={handleSwitch}
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
          /> */}
        </div>
        <div>
        <StatsTable totalCash={totalCash} totalOrdenes={totalItems}/>
        </div>

        <BotonAutorizarMasivo selectedOption={filtro} onOptionChange={handleFiltroChange} />
      </div>

 
      <Table
        size='small'
        rowClassName='size12'
        rowKey='ordenPagoID'
        dataSource={listaFinal}
        columns={columns}
      />
    </CardPage>
  )
    ;
};
